import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import auth from '../functions/auth'

export const ProtectedRoute = ({ component: Component, neededRole }, ...rest) => (
  <Route {...rest} render={
    (props) => {
      if (auth.checkRole() === neededRole) {
        return <Component {...props} />
      } else {
        return <Redirect to={
          {
            pathname: '/',
            state: {
              from: props.location,
            },
          }
        } />
      }


    }
  } />
)
